module.exports = __webpack_public_path__ + "static/media/icon-enfant-sortie.b0b23b80.svg";